import { useLove } from './love'
import { useEnter } from './enter'
import { usePreventReclick } from './prevent-reclick'

const FUNCTION_LIST = [useLove, useEnter, usePreventReclick]

export function directive(app) {
    FUNCTION_LIST.forEach((fun) => {
        fun(app)
    })
}
